(() => {
  const moneyFormatter = (currency) => new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: currency || 'PLN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const jacketHandle = 'kurtka-ogrzewana-czarna-25-stref';
  const jacketSizeSelections = new Map();

  const jacketSelectionKey = (info, tier, slot) => `${info.id || info.dataset.section || 'product'}:${tier}:${slot}`;

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!select.matches?.('[data-pc-jacket-size-slot]')) return;
    const info = select.closest('product-info');
    if (!info) return;
    jacketSizeSelections.set(jacketSelectionKey(info, select.dataset.pcJacketTier, select.dataset.pcJacketSizeSlot), select.value);
  });

  const jacketVariantsForSizes = (sizes, variants, sizeIndex, baseVariant) => {
    const requestedOptions = Array.isArray(baseVariant.options)
      ? [...baseVariant.options]
      : [baseVariant.option1, baseVariant.option2, baseVariant.option3];
    return sizes.map((size) => {
      const options = [...requestedOptions];
      options[sizeIndex] = size;
      return variants.find((variant) => {
        if (!Array.isArray(variant.options)) {
          return variant[`option${sizeIndex + 1}`] === size &&
            requestedOptions.every((value, index) => index === sizeIndex || value == null || variant[`option${index + 1}`] === value);
        }
        return options.every((value, index) => value == null || variant.options[index] === value);
      }) || null;
    });
  };

  const getCartSections = (drawer) => {
    if (typeof drawer?.getSectionsToRender === 'function') return drawer.getSectionsToRender();
    const bubble = document.querySelector('#cart-icon-bubble');
    return [
      ...(drawer ? [{ id: 'cart-drawer', section: drawer.dataset.id || 'cart-drawer', selector: '.drawer__inner' }] : []),
      ...(bubble ? [{ id: 'cart-icon-bubble', section: bubble.dataset.id || 'cart-icon-bubble', selector: '.shopify-section' }] : [])
    ];
  };

  const setJacketError = (root, message = '') => {
    const node = root.querySelector('[data-pc-jacket-error]');
    if (!node) return;
    node.textContent = message;
    node.hidden = !message;
  };

  const handleJacketSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const info = form.closest('product-info');
    const root = info?.querySelector('[data-pc-quantity-tiers]');
    if (!root || root.dataset.productHandle !== jacketHandle) return;
    const tier = root.querySelector('[data-pc-tier]:checked');
    const quantity = Number(tier?.value);
    if (quantity !== 2 && quantity !== 3) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (root.dataset.pcPending === 'true') return;
    root.dataset.pcPending = 'true';
    setJacketError(root);

    const pendingButtons = Array.from(new Set([
      event.submitter,
      ...form.querySelectorAll('[type="submit"]'),
      ...(form.id ? document.querySelectorAll(`[form="${form.id}"]`) : [])
    ].filter((button) => button instanceof HTMLButtonElement)));
    const buttonStates = pendingButtons.map((button) => ({ button, disabled: button.disabled }));
    pendingButtons.forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('loading');
    });

    let cartItemAdded = false;
    try {
      const variants = JSON.parse(root.dataset.variants || '[]');
      const baseVariant = variants.find((variant) => String(variant.id) === String(form.querySelector('input[name="id"]')?.value));
      const sizeIndex = Number(root.querySelector('[data-pc-jacket-sizes]')?.dataset.sizeOption) - 1;
      const selects = Array.from(root.querySelectorAll(`[data-pc-jacket-tier="${quantity}"]`));
      if (!baseVariant || !Number.isInteger(sizeIndex) || sizeIndex < 0 || selects.length !== quantity) {
        throw new Error('Nie można odczytać wybranych wariantów kurtki. Sprawdź rozmiary i spróbuj ponownie.');
      }

      const selectedVariants = jacketVariantsForSizes(selects.map((select) => select.value), variants, sizeIndex, baseVariant);
      if (selectedVariants.some((variant) => !variant || variant.available === false)) {
        throw new Error('Wybrany rozmiar kurtki jest niedostępny. Wybierz inny rozmiar i spróbuj ponownie.');
      }

      const quantities = new Map();
      selectedVariants.forEach((variant) => quantities.set(String(variant.id), (quantities.get(String(variant.id)) || 0) + 1));
      const items = Array.from(quantities, ([id, itemQuantity]) => ({ id: Number(id), quantity: itemQuantity }));
      const drawer = document.querySelector('cart-drawer');
      const sections = getCartSections(drawer);
      const themeRoutes = typeof routes !== 'undefined' ? routes : window.routes;
      const requestUrl = themeRoutes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      const response = await fetch(requestUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items,
          ...(sections.length ? { sections: sections.map((section) => section.id), sections_url: window.location.pathname } : {})
        })
      });
      let result = {};
      try { result = await response.json(); } catch (_) { /* Non-JSON responses use the translated fallback below. */ }
      if (!response.ok || result.status) {
        throw new Error('Nie udało się dodać produktów do koszyka. Spróbuj ponownie.');
      }
      cartItemAdded = true;
      const trigger = event.submitter || form.querySelector('[type="submit"]');
      if (typeof drawer?.renderContents === 'function' && typeof drawer?.open === 'function') {
        try {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result, trigger);
          drawer.open(trigger);
        } catch (_) {
          window.location.assign(themeRoutes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
        }
      } else window.location.assign(themeRoutes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      if (cartItemAdded) {
        const themeRoutes = typeof routes !== 'undefined' ? routes : window.routes;
        window.location.assign(themeRoutes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
      } else {
        const knownMessages = [
          'Nie można odczytać wybranych wariantów kurtki. Sprawdź rozmiary i spróbuj ponownie.',
          'Wybrany rozmiar kurtki jest niedostępny. Wybierz inny rozmiar i spróbuj ponownie.'
        ];
        setJacketError(root, knownMessages.includes(error.message) ? error.message : 'Nie udało się dodać produktów do koszyka. Spróbuj ponownie.');
      }
    } finally {
      root.dataset.pcPending = 'false';
      buttonStates.forEach(({ button, disabled }) => {
        button.disabled = disabled;
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
      });
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button.main-product-atc[type="button"], button.sticky-atc__add_button[type="button"]');
    if (!button) return;
    const form = button.form || (button.getAttribute('form') ? document.getElementById(button.getAttribute('form')) : null);
    if (!(form instanceof HTMLFormElement)) return;
    const root = form.closest('product-info')?.querySelector('[data-pc-quantity-tiers]');
    const quantity = Number(root?.querySelector('[data-pc-tier]:checked')?.value);
    if (root?.dataset.productHandle !== jacketHandle || (quantity !== 2 && quantity !== 3)) return;

    handleJacketSubmit({
      target: form,
      submitter: button,
      preventDefault: () => event.preventDefault(),
      stopImmediatePropagation: () => event.stopImmediatePropagation()
    });
  }, true);

  document.addEventListener('submit', handleJacketSubmit, true);

  const initTierCards = (root) => {
    if (root.dataset.pcReady === 'true') return;
    const info = root.closest('product-info');
    const quantityInput = info?.querySelector('input[name="quantity"]');
    const variantInput = info?.querySelector('form input[name="id"]');
    if (!info || !quantityInput || !variantInput) return;

    root.dataset.pcReady = 'true';
    info.classList.add('product-info--pc-tiers');
    const variants = JSON.parse(root.dataset.variants || '[]');
    const tiers = Array.from(root.querySelectorAll('[data-pc-tier]'));
    const currency = root.dataset.currency || 'PLN';
    const formatter = moneyFormatter(currency);
    const discountTwo = Number(root.dataset.discountTwo || 0);
    const discountThree = Number(root.dataset.discountThree || 0);
    const isJacket = root.dataset.productHandle === jacketHandle;
    const sizeWrapper = root.querySelector('[data-pc-jacket-sizes]');
    const sizeIndex = Number(sizeWrapper?.dataset.sizeOption) - 1;
    if (sizeWrapper) {
      sizeWrapper.querySelectorAll('[data-pc-jacket-size-slot]').forEach((select) => {
        const key = jacketSelectionKey(info, select.dataset.pcJacketTier, select.dataset.pcJacketSizeSlot);
        const savedValue = jacketSizeSelections.get(key);
        if (savedValue && Array.from(select.options).some((option) => option.value === savedValue)) select.value = savedValue;
        else jacketSizeSelections.set(key, select.value);
      });
    }

    const refresh = () => {
      const currentVariantInput = info.querySelector('form input[name="id"]');
      const variant = variants.find((item) => String(item.id) === String(currentVariantInput?.value));
      if (!variant) return;
      const rule = variant.quantity_rule || {};
      const ruleMin = Number(rule.min ?? quantityInput.dataset.min ?? quantityInput.min);
      const min = Number.isFinite(ruleMin) && ruleMin > 0 ? ruleMin : 1;
      const rawMax = rule.max ?? quantityInput.dataset.max ?? quantityInput.max;
      const parsedMax = rawMax == null || rawMax === '' || String(rawMax).toLowerCase() === 'null' ? Infinity : Number(rawMax);
      const max = Number.isFinite(parsedMax) && parsedMax > 0 ? parsedMax : Infinity;
      const ruleIncrement = Number(rule.increment ?? quantityInput.step);
      const increment = Number.isFinite(ruleIncrement) && ruleIncrement > 0 ? ruleIncrement : 1;
      const currentQuantity = Number(quantityInput.value);
      let selected = Number.isFinite(currentQuantity) && currentQuantity > 0 ? currentQuantity : min;
      const validity = new Map();
      const totals = new Map();

      tiers.forEach((input) => {
        const quantity = Number(input.value);
        const card = input.closest('[data-pc-tier-card]');
        const discount = quantity === 2 ? discountTwo : quantity === 3 ? discountThree : 0;
        const selects = isJacket && quantity > 1
          ? Array.from(root.querySelectorAll(`[data-pc-jacket-tier="${quantity}"]`))
          : [];
        const selectedVariants = selects.length === quantity
          ? jacketVariantsForSizes(selects.map((select) => select.value), variants, sizeIndex, variant)
          : [];
        const tierValid = quantity === 1 || !isJacket || (
          selectedVariants.length === quantity && selectedVariants.every((item) => item && item.available !== false)
        );
        const unitSum = isJacket && quantity > 1 && tierValid
          ? selectedVariants.reduce((sum, item) => sum + item.price, 0)
          : variant.price * quantity;
        const total = Math.max(0, unitSum - discount);
        const compareTotal = isJacket && quantity > 1 && tierValid
          ? selectedVariants.reduce((sum, item) => sum + (item.compare_at_price || item.price), 0)
          : (variant.compare_at_price || variant.price) * quantity;
        totals.set(input, { total, compareTotal, tierValid });
        const totalNode = card.querySelector('[data-pc-total]');
        const savingNode = card.querySelector('[data-pc-saving]');
        const discountNode = card.querySelector('[data-pc-discount]');
        if (discountNode) {
          const percentage = unitSum > 0 ? Math.round(discount * 100 / unitSum) : 0;
          discountNode.hidden = !tierValid || discount <= 0 || percentage <= 0;
          discountNode.textContent = `−${percentage}%`;
          discountNode.title = `Rabat względem zakupu ${quantity} pojedynczych sztuk za ${formatter.format(unitSum / 100)}. Procent zaokrąglony.`;
        }
        const validRule = quantity >= min && quantity <= max && (quantity - min) % increment === 0;
        input.disabled = !variant.available || !validRule;
        validity.set(input, !input.disabled);
        card.classList.toggle('is-unavailable', input.disabled);
        if (totalNode) totalNode.textContent = !tierValid && isJacket && quantity > 1 ? 'Sprawdź rozmiary' : formatter.format(total / 100);
        if (savingNode) savingNode.textContent = discount > 0 && tierValid ? `Oszczędzasz ${formatter.format(discount / 100)}` : '';
        card.classList.toggle('has-invalid-sizes', isJacket && quantity > 1 && !tierValid);
      });

      const selectedInput = tiers.find((input) => Number(input.value) === selected && validity.get(input)) || tiers.find((input) => validity.get(input));
      if (selectedInput) {
        selected = Number(selectedInput.value);
        if (Number(quantityInput.value) !== selected) quantityInput.value = String(selected);
      }
      tiers.forEach((input) => {
        const card = input.closest('[data-pc-tier-card]');
        input.checked = input === selectedInput;
        card.classList.toggle('is-selected', input === selectedInput);
      });
      const selectedTotal = totals.get(selectedInput);
      if (selectedTotal) {
        const { total, compareTotal, tierValid } = selectedTotal;
        const setText = (node, value) => {
          if (node && node.textContent !== value) node.textContent = value;
        };
        info.querySelectorAll('.product-page-price .price').forEach((price) => {
          const displayedTotal = tierValid ? formatter.format(total / 100) : 'Sprawdź rozmiary';
          setText(price.querySelector('.price__regular .price-item--regular'), displayedTotal);
          setText(price.querySelector('.price__sale .price-item--sale'), displayedTotal);
          setText(price.querySelector('.price__compare-price .price-item--regular'), formatter.format(compareTotal / 100));
          price.classList.toggle('price--on-sale', tierValid && compareTotal > total);
          setText(price.querySelector('.badge__percentage-saved'), String(compareTotal > 0 ? Math.floor((compareTotal - total) * 100 / compareTotal) : 0));
          setText(price.querySelector('.badge__money-saved'), formatter.format((compareTotal - total) / 100));
        });
      }
      info.classList.toggle('product-info--pc-mixed', isJacket && Number(selectedInput?.value) > 1);
      root.querySelectorAll('[data-pc-jacket-size-group]').forEach((group) => {
        const active = tiers.find((input) => Number(input.value) === Number(group.dataset.pcJacketSizeGroup))?.checked;
        group.hidden = !active;
      });
    };

    // Shopify replaces the price HTML after a variant change. Reapply the
    // selected offer to that new markup, without looping on our own text writes.
    root.pcRefreshPrice = refresh;
    const observerRoot = info.closest('[id^="MainProduct-"]') || info;
    if (observerRoot.dataset.pcTierObserver !== 'true') {
      observerRoot.dataset.pcTierObserver = 'true';
      new MutationObserver((records) => {
        const priceChanged = records.some((record) =>
          record.target instanceof Element && (
            record.target.closest('.product-page-price') ||
            Array.from(record.addedNodes).some((node) => node instanceof Element && (
              node.matches('.product-page-price') || node.querySelector('.product-page-price')
            ))
          )
        );
        observerRoot.querySelectorAll('[data-pc-quantity-tiers]').forEach((tierRoot) => {
          initTierCards(tierRoot);
          if (priceChanged) tierRoot.pcRefreshPrice?.();
        });
      }).observe(observerRoot, { childList: true, subtree: true });
    }

    tiers.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked || input.disabled) return;
        quantityInput.value = input.value;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      });
    });

    quantityInput.addEventListener('input', refresh);
    quantityInput.addEventListener('change', refresh);
    variantInput.addEventListener('change', refresh);
    info.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]')) window.setTimeout(refresh, 0);
    });
    info.addEventListener('variant:change', refresh);
    if (sizeWrapper) {
      sizeWrapper.addEventListener('change', (event) => {
        if (event.target.matches('[data-pc-jacket-size-slot]')) {
          setJacketError(root);
          refresh();
        }
      });
      root.querySelectorAll('[data-pc-jacket-size-group]').forEach((group) => {
        const quantity = Number(group.dataset.pcJacketSizeGroup);
        const tier = tiers.find((input) => Number(input.value) === quantity);
        const toggleGroup = () => { group.hidden = !tier?.checked; };
        tier?.addEventListener('change', toggleGroup);
        toggleGroup();
      });
    }
    refresh();
  };

  const init = () => {
    document.querySelectorAll('[data-pc-quantity-tiers]').forEach(initTierCards);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


